export default __webpack_public_path__ + "ec0723cb5a418190d4c36df094136613.png";